"use client";

import { useRouter } from "next/navigation";
import { useSyncedState } from "@/hooks/use-synced-state";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface BlogSearchProps {
  defaultQuery?: string;
  className?: string;
}

export function BlogSearch({ defaultQuery = "", className }: BlogSearchProps) {
  const router = useRouter();
  const [value, setValue] = useSyncedState(defaultQuery);

  function submit(event: React.FormEvent) {
    event.preventDefault();
    const trimmed = value.trim();
    const target = trimmed ? `/blog?q=${encodeURIComponent(trimmed)}` : "/blog";
    router.push(target);
  }

  return (
    <form role="search" onSubmit={submit} className={cn("flex gap-2", className)}>
      <label className="flex-1">
        <span className="sr-only">Search the blog</span>
        <Input
          type="search"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="Search articles"
        />
      </label>
      <Button type="submit" variant="outline">
        Search
      </Button>
    </form>
  );
}
